import React from 'react';

import {
  DEFAULT_PLATE_SIZE,
  INSERTABLE_WELL_PLATE_SIZE_OPTIONS,
} from 'notebook/tables/constants/TableLayoutConstants';
import getPresetPlateSizes from 'settings/samples/getPresetPlateSizes';
import {useCloseableDropdownContext} from 'ui-library/dropdowns/CloseableDropdownContext';
import Option from 'ui-library/menus/Option';

interface InsertWellPlateMenuProps {
  insertWellPlateWithDimensions: (numRows: number, numCols: number) => void;
}

/**
 * A light-weight React component that renders a menu for selecting well-plate dimensions.
 * The default plate size starts highlighted.
 */

export default function InsertWellPlateMenu({
  insertWellPlateWithDimensions,
}: InsertWellPlateMenuProps): JSX.Element {
  const {onCloseDropdown} = useCloseableDropdownContext();
  const [hasHovered, setHasHovered] = React.useState(false);

  const plateSizeOptions = getPresetPlateSizes(INSERTABLE_WELL_PLATE_SIZE_OPTIONS);

  return (
    <>
      {plateSizeOptions.map(([y, x], i) => (
        <Option
          key={i}
          value={[y, x]}
          isHovered={
            !hasHovered && y === DEFAULT_PLATE_SIZE[0] && x === DEFAULT_PLATE_SIZE[1] ? true : undefined
          }
          onHover={() => {
            setHasHovered(true);
          }}
          onSelect={() => {
            insertWellPlateWithDimensions(y, x);
            onCloseDropdown();
          }}
          disableEventPropagation={true}
        >
          {`${x * y}-well plate (${y} x ${x})`}
        </Option>
      ))}
    </>
  );
}
